import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheFutureOfHomecareSafety from "./sections/TheFutureOfHomecareSafety";
import ComprehensiveCareSolutions from "./sections/ComprehensiveCareSolutions";
import CommonQuestions from "./sections/CommonQuestions";
import TheMedacubeAdvantage from "./sections/TheMedacubeAdvantage";
import Testimonials from "./sections/Testimonials";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheFutureOfHomecareSafety />
      <ComprehensiveCareSolutions />
      <CommonQuestions />
      <Testimonials />
      <TheMedacubeAdvantage />
      <SiteFooter />
    </div>;
}